import { render } from "./DocHubDoc.vue?vue&type=template&id=8087c07a"
import script from "./DocHubDoc.vue?vue&type=script&lang=js"
export * from "./DocHubDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__